"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useSessionStorage_1 = require("./useSessionStorage");
Object.defineProperty(exports, "useSessionStorage", { enumerable: true, get: function () { return useSessionStorage_1.default; } });
